import { render, staticRenderFns } from "./waterFilter.vue?vue&type=template&id=be2e3c66&scoped=true"
import script from "./waterFilter.vue?vue&type=script&lang=js"
export * from "./waterFilter.vue?vue&type=script&lang=js"
import style0 from "./waterFilter.vue?vue&type=style&index=0&id=be2e3c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e3c66",
  null
  
)

export default component.exports